import React, { useState } from 'react'
import { Routes, Route } from 'react-router-dom';
import SideBar from './Components/SideBar';
import Message from './Components/Message';
import Dashboard from './Components/Layout/Dashboard';
import ProfileUpdate from './Components/Layout/ProfileUpdate';
// import CompanyUpdate from './Components/Layout/CompanyUpdate';
import AllPackages from './Components/AllPackages';
import AddPackage from './Components/AddPackage';
import AddDepartement from './Components/AddDepartement';
import AllDepartment from './Components/AllDepartment';
import AllPackageGrp from './Components/AllPackageGrp';
import MembershipManage from './Components/Layout/MembershipManage';
import AddPkgGrp from './Components/AddPkgGrp';
import AddPeriod from './Components/AddPeriod';
import AllPkgPeriod from './Components/AllPkgPeriod';
import AddInquiry from './Components/AddInquiry';
import AllInquiry from './Components/AllInquiry';
// import AddFollowup from './Components/AddFollowup';
import AddMember from './Components/AddMember';
import PasswordChange from './Components/Layout/PasswordChange';
import AllMembers from './Components/AllMembers';
import AllExpenses from './Components/AllExpenses';
import AddExpenses from './Components/AddExpenses';
import AddInvoice from './Components/AddInvoice';
import AllInvoices from './Components/AllInvoices';
import MessageTemplate from './Components/Layout/MessageTemplate';
import RemainingBalance from './Components/RemainingBalance';
import AccountStatement from './Components/AccountStatement';
import MassageUpdate from './Components/Layout/MassageUpdate';
import MembershipAgreement from './Components/MembershipAgreement';

const App = () => {
  const [isShow, setIsShow] = useState(true);

  return (
    <div className='md:flex m-0 p-0 box-border max-w-[2000px] 2xl:mx-auto'>
      <SideBar isShow={isShow} setIsShow={setIsShow} />
      <Routes>
        <Route path='/' element={<Dashboard isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/dashboard' element={<Dashboard isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/' element={<Dashboard isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/SMS/message' element={<Message isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/package/all' element={<AllPackages isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/package/' element={<AddPackage isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/package/:slug' element={<AddPackage isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/department/all' element={<AllDepartment isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/department/' element={<AddDepartement isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/department/:slug' element={<AddDepartement isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/programgrp/all' element={<AllPackageGrp isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/programgrp/' element={<AddPkgGrp isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/programgrp/:slug' element={<AddPkgGrp isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/periodmaster/all' element={<AllPkgPeriod isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/periodmaster/' element={<AddPeriod isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/periodmaster/:slug' element={<AddPeriod isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/enquiry/all' element={<AllInquiry isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/enquiry/' element={<AddInquiry isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/enquiry/:slug' element={<AddInquiry isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/members/all' element={<AllMembers isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/members/' element={<AddMember isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/members/:slug' element={<AddMember isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/members/package/:slug' element={<AddMember isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/expenses/all' element={<AllExpenses isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/expenses/' element={<AddExpenses isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/expenses/:slug' element={<AddExpenses isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/receipt/all' element={<AllInvoices isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/receipt/' element={<AddInvoice isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/receipt/:slug' element={<AddInvoice isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/outstanding' element={<RemainingBalance isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/report' element={<AccountStatement isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/ProfileDetails' element={<ProfileUpdate isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/admin/termsconditions' element={<MembershipAgreement isShow={isShow} setIsShow={setIsShow} />} />
        {/* <Route path='/CompanyDetails' element={<CompanyUpdate isShow={isShow} setIsShow={setIsShow} />} /> */}
        <Route path='/MemberManage' element={<MembershipManage isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/Admin/ChangePassword' element={<PasswordChange isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/Admin/Template/Edit' element={<MassageUpdate isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/Admin/Template' element={<MessageTemplate isShow={isShow} setIsShow={setIsShow} />} />
        <Route path='/Admin/Template/Edit' element={<MassageUpdate isShow={isShow} setIsShow={setIsShow} />} />
      </Routes>
    </div>
  )
}

export default App;